import AboutCard from "../../components/About/AboutCard";

const AboutMePage = () => {
  return (
    <div className="container">
      <AboutCard />
    </div>
  );
};

export default AboutMePage;
